// extracted by mini-css-extract-plugin
module.exports = {"voucherControl":"voucher-control_voucherControl__k_aYr"};